import React from 'react';
import type { ProgramExportTrackTimetableParts } from '../../utils/programExportDocumentTitle';

export type ProgramExportTrackTimetableStackProps = ProgramExportTrackTimetableParts & {
  suffix?: string;
  className?: string;
};

const ProgramExportTrackTimetableStack: React.FC<ProgramExportTrackTimetableStackProps> = ({
  trackLabel = '',
  timetableLabel = '',
  suffix = '',
  className = '',
}) => {
  const track = trackLabel.trim();
  const timetable = timetableLabel.trim();
  const showBoth = !!track && !!timetable && track !== timetable;
  const showTrackOnly = !!track && (!timetable || track === timetable);
  const showTimetableOnly = !track && !!timetable;

  if (!showBoth && !showTrackOnly && !showTimetableOnly) {
    return suffix ? <span className={className}>{suffix}</span> : null;
  }

  return (
    <span className={['cp-program-export-track-timetable-stack', className].filter(Boolean).join(' ')}>
      {showBoth ? (
        <>
          <span className="cp-program-export-track-timetable-line">{track}</span>
          <span className="cp-program-export-track-timetable-line">
            ({timetable}){suffix}
          </span>
        </>
      ) : showTimetableOnly ? (
        <span className="cp-program-export-track-timetable-line">
          ({timetable}){suffix}
        </span>
      ) : (
        <span className="cp-program-export-track-timetable-line">
          {track}
          {suffix}
        </span>
      )}
    </span>
  );
};

export default ProgramExportTrackTimetableStack;
